import PocketBase from 'pocketbase';
import { getSharedConfig } from './config';

let instance: PocketBase | null = null;

/** Lazy PocketBase singleton — created on first use so configureShared()
 *  can run first (import order is not enough across app entrypoints). */
export function getPb(): PocketBase {
  if (!instance) {
    instance = new PocketBase(getSharedConfig().pocketbaseUrl);
    instance.autoCancellation(false);
  }
  return instance;
}
